<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>FOR TESS KISSINGER AND BOB WALTERS<br/>who didn’t suspect I was stealing part of their story</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7b12298c